import styled from '@emotion/styled'

export const StyleMatchroomTitle = styled.p`
  text-align: center;
  color: ${(props: any) => props.theme.colors.primary};
  font-size: 18px;
  margin-bottom: 32px;
`

export const StyleMatchroomContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 18px;
`

export const StyleMatchroomInfo = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: flex-start;
  width: 105%;
  color: ${(props: any) => props.theme.colors.text};
`

export const StyleLabel = styled.p`
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 20px;
`
export const StyleTextContaienr = styled.div<{ borderColor?: string }>`
  padding: 0px 12px;
  display: flex;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.25px;
  border-radius: 6px;
  height: 50px;
  border: 1px solid
    ${(props: any) => props.borderColor || props.theme.colors.borderColor};
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const RoomInfoWrapper = styled.div`
  padding: 16px 18px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px;
  border-radius: 20px;
  place-items: center;

  background-color: ${(props: any) => props.theme.colors.primaryLight};
`
